module.exports = "https://www.ilove11.top/img/icepay-logo.39950744.png";